// extracted by mini-css-extract-plugin
export var locationCard = "_qc-0";